import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const basicprofilebase = config.jmw_market_env + config.jmw_market + "profile/";
const leadBase = config.jmw_market_env + config.jmw_market + "lead/";
const serviceRequest = "servicerequest";
const BasicProfileURL = {
    getBrokerageSegments: config.jmw + basicprofilebase + "brokerageDetails",
    nomineeDetails: config.jmw + config.edelmw_sr + serviceRequest + "sr/getnomineedetails",
    advisorRating: config.jmw + config.jmw_login + "raterm/submit/",
    clientDetails: config.jmw + basicprofilebase + "clientDetails",
    deviceRegister: config.jmw + config.jmw_login + "devices/register",
    getRegisteredDevices: config.jmw + config.jmw_login + "devices/registered",
    deRegisterDevice: config.jmw + config.jmw_login + "devices/deregister",
    getProfilePicture: config.jmw + basicprofilebase + "getProfilePic",
    saveprofilepicture: config.jmw + basicprofilebase + "saveProfilePic",
    deleteProfilePicture: config.jmw + basicprofilebase + "deleteProfilePic",
    viewCommunicationDetails: config.jmw + basicprofilebase + "viewCommSettings",
    saveCommunicationDetails: config.jmw + basicprofilebase + "saveCommSettings",
    getRmDetails: config.jmw + basicprofilebase + "rmCommonData",
    whatsappConsent: config.jmw + config.jmw_login + "/consent/whatsapp",
    downloadKYCData: config.jmw + basicprofilebase + "downloadKyc",
    defaultExchange: config.jmw + config.jmw_eq + "client-details/default-exchange",
    wealthAdvisor: config.jmw + basicprofilebase + "wealthAdvisors",
    savelead: config.jmw + leadBase + "saveleadinfo_v1",
    deleteUpi: config.jmw + config.jmw_eq + "fund/upi/",
};
export default BasicProfileURL;
